import React from "react";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,

    Box,
    Skeleton, Grid, Pagination,
} from "@mui/material";

const TableCustom = ({ data, isLoad, onToggleSort, sortOrder, totalPage, currentPage, onChangePage }) => {
    const handleChangePage = (event, newPage) => {
        onChangePage(newPage, true)
    }

    return (
		<>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell>Запрос</TableCell>
						<TableCell
							onClick={onToggleSort}
							style={{ cursor: "pointer" }}
						>
							Кол-во {sortOrder === "ASC" ? "▲" : "▼"}
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{!isLoad && data.map((item, idx) => (
						<RowData key={idx} item={item} />
					))}
					{isLoad && <RowsLoading />}
				</TableBody>
			</Table>

            <Grid container justifyContent="flex-end" mt={2}>
                <Grid item>
                    <Pagination
                        count={Number.parseFloat(totalPage || 0)}
                        page={Number.parseFloat(currentPage)}
                        onChange={handleChangePage}
                    />
                </Grid>
            </Grid>
		</>
	);
};

const RowData = React.memo((props) => {
	const {
		item
	} = props;

	return (
		<>
			<TableRow>
				<TableCell>
					{item.search}
				</TableCell>
				<TableCell>
					{item.total_count}
				</TableCell>
			</TableRow>

		</>
	)
})
const RowsLoading = React.memo(() => {
	return new Array(10).fill(1).map(() => (
		<TableRow>
			<TableCell><Skeleton/></TableCell>
			<TableCell><Skeleton/></TableCell>
		</TableRow>
	))
})

export default React.memo(TableCustom)
